import React, { useEffect } from "react"
import styled from "styled-components"
import Navbar from "components/elements/Navbar"
import Footer from "components/sections/Footer"
import { ReactNode } from "react"
import { initPixel } from "analytics/manager"
import PropTypes from "prop-types"
import { Fade } from "@material-ui/core"
import { useLocation } from "@reach/router"

const StyledDiv = styled.div`
  a {
    text-decoration: none;
  }
  overflow: hidden;

  background-color: #fff;
`

interface Props {
  children: ReactNode
}

const Layout = ({ children }: Props) => {
  const location = useLocation()
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (location.href.includes("/#/terms?isMobileView=true")) {
        window.open(
          "https://play.sixergame.com/#/terms?isMobileView=true",
          "_self",
        )
      } else if (location.href.includes("/#/privacy")) {
        window.open(
          "https://play.sixergame.com/#/privacy?isMobileView=true",
          "_self",
        )
      } else if (location.href.includes("/#/gamerules?isMobileView=true")) {
        window.open(
          "https://play.sixergame.com/#/gamerules?isMobileView=true",
          "_self",
        )
      } else if (location.href.includes("/#/scoringsystem?isMobileView=true")) {
        window.open(
          "https://play.sixergame.com/#/scoringsystem?isMobileView=true",
          "_self",
        )
      } else if (location.href.includes("/#/performance_scoring_system")) {
        window.open(
          "https://play.sixergame.com/#/sixer2_performance_scoring_system",
          "_self",
        )
      } else if (location.href.includes("/#/faq?isMobileView=true")) {
        window.open("https://scoring.sixergame.com/faqs", "_self")
      } else if (location.href.includes("/#/faq")) {
        window.open("https://scoring.sixergame.com/faqs", "_self")
      }
    }
    initPixel()
  }, [])

  return (
    <StyledDiv>
      <Fade in mountOnEnter unmountOnExit>
        <main>
          {!location.pathname.includes("download") && <Navbar />}
          {children}
          <Footer />
        </main>
      </Fade>
    </StyledDiv>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
